import { intersect } from './intersect';
import { isMobile } from './device-utils';

const heroLMP = document.querySelector<HTMLElement>('.j-intro[data-hero-slim= sticky]');
const heroLGP = document.querySelector<HTMLElement>('.ftbl__lgp-hero-container[data-hero-slim= sticky]');
const heroSlimLMP = document.querySelector<HTMLElement>('.j-hero-lmp-slim[data-hero-slim= sticky]');
const heroSlimLGP = document.querySelector<HTMLElement>('.ftbl__lgp-hero-sticky-container[data-hero-slim= sticky]');

const heroArray: (HTMLElement | null)[] = [heroLMP, heroLGP];
const heroSlimArray: (HTMLElement | null)[] = [heroSlimLMP, heroSlimLGP];

const toIntersect = (item: HTMLElement) => {
  if (item.parentNode) {
    Array.prototype.filter.call(item.parentNode.children, (i: HTMLElement) => {
      if (i.dataset.heroSlim === 'sticky') {
        i.dataset.state = 'isHidden';
      }
    });

    item.dataset.state = 'isVisible';
  }
};

export const heroSlimSticky = () => {
  const localNavElement = document.querySelector<HTMLElement>('.j-local-nav');
  const sectionNavElement = document.querySelector<HTMLElement>('.j-section-nav');
  const tabsMenuElement = document.querySelector<HTMLElement>('.j-tabs-menu');

  const hero = heroArray.find((el) => Boolean(el));
  const heroSlim = heroSlimArray.find((el) => Boolean(el));

  if (!hero || !heroSlim || !localNavElement || !sectionNavElement) {
    // eslint-disable-next-line no-console
    console.info('🚫 HERO SLIM STICKY disabled');
    return;
  }

  // eslint-disable-next-line no-console
  console.info('🚫🚫🚫🚫🚫🚫🚫');

  function getPageType(): 'lgp' | 'lmp' | null {
    const tabsList = document.querySelector<HTMLHtmlElement>(
      '.ftbl__tabs-menu:not(.pp-menu-tabs):not(.ftbl__tabs-menu--chips)'
    );

    return tabsList?.dataset.section === 'lgp' ? 'lgp' : 'lmp';
  }

  const heroSlimElementHeightDefaults: { lmp: number; lgp: number } = {
    lmp: isMobile() ? 70 : 60,
    lgp: isMobile() ? 63 : 66,
  };
  const heroElementHeight = hero.getBoundingClientRect().height;
  const heroSlimElementHeight =
    heroSlim.getBoundingClientRect().height || heroSlimElementHeightDefaults[getPageType() as 'lgp' | 'lmp'];
  const localNavElementHeight = localNavElement.getBoundingClientRect().height;
  const sectionNavElementHeight = sectionNavElement.getBoundingClientRect().height;

  let sumStickyElements: number = isMobile()
    ? localNavElementHeight + heroSlimElementHeight // use the local nav because in mobile the section nav is in display none
    : localNavElementHeight + sectionNavElementHeight + heroSlimElementHeight;

  const threshold = ((100 / heroElementHeight) * sumStickyElements) / 100;

  heroSlim.style.top = isMobile()
    ? `${localNavElementHeight}px` // use the local nav because in mobile the section nav is in display none
    : `${localNavElementHeight + sectionNavElementHeight}px`;
  heroSlim.style.marginTop = `-${heroSlimElementHeight}px`;

  if (tabsMenuElement) {
    sumStickyElements = sumStickyElements > 196 ? 130 : sumStickyElements;
    tabsMenuElement.style.top = `${sumStickyElements - 1}px`;
  }

  const intersector = intersect('[data-hero-slim= sticky]', threshold);
  intersector(toIntersect);
};
